<template>

    <div :class="[!is_enabled ? 'cursor-pointer hover:bg-gray-100' : '', 'group']" @click="clickRow">

        <div class="flex items-center font-bold flex-row justify-between px-4 py-5 sm:p-6">

            <div class="flex flex-grow items-center gap-3">
                <div class="w-12 h-12 rounded-2xl flex items-center justify-center" style="background-color:#FF8D00;">
                    <img src="/img/happyfox_white.svg" class="h-7 w-7" />
                </div>
                <div class="flex flex-col items-start">
                    <span>Happyfox</span>
                </div>
            </div>
            <div class="flex text-white bg items-center" v-if="trigger">
                <div
                    class="inline-flex items-center px-0 py-2 bg-white border border-transparent rounded-md font-semibold text-xs text-birdie-green uppercase tracking-widest ">
                    Connected
                </div>
            </div>
            <transition name="fade">
                <div class="flex text-blue-500 items-center" v-if="expandInfo && !is_enabled"
                    :class="{ 'opacity-50 pointer-events-none': !$page.props.canManageSettings }">
                    <button-link link="#" @click.prevent.stop="openModal" class=""
                        :title="'Connect Birdie with Happyfox'">
                        Connect
                    </button-link>
                </div>
            </transition>
        </div>


        <Flows :visible="expandInfo" :fixed="is_enabled" :flows="flows" :docs="docs" :name="name" />



        <div v-if="trigger" class="bg-gray-50 rounded-b-md px-4 py-5 sm:p-8 border-t border-gray-100">

            <div class="flex flex-col mt-3" v-if="!is_modal">
                <div class="flex items-center flex-grow">
                    <div class="flex justify-between w-full items-center gap-x-2">
                        <span class="flex flex-shrink items-center gap-x-2">
                            <!-- <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4" /> -->
                            Birdie is connected to your account <span
                                class="bg-white text-gray-500 text-sm px-3 py-1 rounded flex items-center">{{
                                    trigger.identifier }}</span>
                        </span>

                        <button-link link="#" @click.prevent="openModal"
                            :class="{ 'pointer-events-none': !$page.props.canManageSettings }" class="bg-birdie-blue"
                            :title="'Edit'">
                            <PencilSquareIcon class="h-3 w-3 mr-1" /> Edit
                        </button-link>


                    </div>
                </div>
            </div>



            <jet-section-border />


            <div class="flex flex-col mt-3" v-if="!is_modal">
                <div class="flex items-center flex-grow">
                    <div class="flex flex-col justify-between items-start gap-x-2">
                        <span class="flex flex-shrink items-center gap-x-2">
                            <!-- <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4" /> -->
                            The recording link to paste into your canned answer automation
                            <docs-link
                                href="https://docs.birdie.so/birdie-docs/helpdesk/happyfox/screen-recording/agent-view" />
                        </span>

                        <div class="flex justify-between text-sm">
                            <span
                                class="cursor-pointer bg-gray-200 text-gray-500 hover:text-gray-600 px-3 py-1 rounded mt-1 flex items-center flex-shrink"
                                v-clipboard:copy="happyfox_canned_answer" v-clipboard:success="confirmCopy">{{
                                    happyfox_canned_answer }}
                                <ClipboardIcon class="h-3 w-3 ml-1" v-tippy="{ content: 'copy in your clipboard' }" />
                            </span>
                            <div class="flex flex-grow"></div>
                        </div>
                    </div>
                </div>
            </div>

            <jet-section-border />


            <div class="flex flex-col" v-if="trigger && !is_modal">

                <div class="flex justify-between items-center pr-2 mt-3">
                    <h2 class="font-bold flex items-center gap-x-2">
                        <!-- <img src="/img/screen-recording.svg" alt="Screen Recording" class="w-4 h-4" /> -->
                        Happyfox Ticket Form | Optional
                    </h2>

                </div>
                <h3 class="flex items-center">Add Birdie to your Happyfox Ticket Form &nbsp;<docs-link
                        href="https://docs.birdie.so/birdie-docs/helpdesk/happyfox/screen-recording/support-center-ticket-form" />
                </h3>

                <div class="mt-4">
                    <div class="relative rounded-xl overflow-hidden code_background">
                        <highlightjs class="overflow-auto px-5 py-4 whitespace-pre-wrap text-sm max-h-36"
                            language='javascript' :code="happyfox_snippet" />
                        <a href="#" v-clipboard:copy="happyfox_snippet" @click.prevent.stop="copied"
                            class="absolute top-3 right-3 w-10 h-10 bg-gray-100 text-gray-800 flex flex-col justify-center items-center rounded-lg bg-opacity-50 transform duration-200 hover:bg-opacity-100 hover:scale-105"
                            v-tippy="{ content: 'copy in your clipboard' }">
                            <ClipboardIcon class="h-5 w-5" />
                        </a>
                    </div>
                </div>

            </div>

        </div>




        <modal-happyfox ref="modalApikey" :initial_domain="initial_domain" :saving="saving"
            @callback="updateTrigger"></modal-happyfox>

    </div>

</template>

<script>
import Toggle from '@/Components/UI/Toggle'
import ButtonLink from '@/Jetstream/ButtonLink'
import ListToggle from '@/Components/UI/ListToggle'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetDialogModal from '@/Jetstream/DialogModal'
import JetDangerButton from '@/Jetstream/DangerButton'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import { PencilSquareIcon } from "@heroicons/vue/20/solid"
import { ClipboardIcon } from "@heroicons/vue/16/solid"
import JetSectionBorder from '@/Jetstream/SectionBorder'
import ModalHappyfox from '@/Components/Modals/ModalHappyfox'
import Flows from '@/Components/Settings/Integrations/Flows'

import 'highlight.js/styles/github-dark.css'
import hljsVuePlugin from "@highlightjs/vue-plugin"


export default {

    props: ['the_trigger', "is_modal", "happyfox_snippet", "flows", "docs", "name"],

    components: {
        Toggle, ButtonLink, ListToggle, JetSecondaryButton,
        JetDropdown, JetDropdownLink, JetDialogModal,
        JetDangerButton, JetSectionBorder,
        PencilSquareIcon, ModalHappyfox, ClipboardIcon,
        highlightjs: hljsVuePlugin.component, Flows
    },

    created: function () {
        if (this.the_trigger) {
            this.trigger = this.the_trigger
            if (this.trigger.identifier) {
                this.initial_domain = this.trigger.identifier
            }
            // this.getEmbedCode()
            // console.log(this.happyfox_snippet)
        }
    },

    data() {
        return {
            trigger: null,
            engine: {},
            mailboxes: [],
            mailbox_default_id: 0,
            mailbox_default_name: '',
            helpscout_app_url: this.$page.props.app_url + "/helpscout",
            helpscout_app_secret: this.$page.props.md5_teamslug,
            show_delete_modal: false,
            agents_can: 'all',
            app_name: this.$page.props.app_name,
            openInstall: false,
            saving: false,
            initial_domain: "",
            credentials_error: false,
            embedCode: '',
            is_enabled: this.the_trigger != false,
            expandInfo: false
        }
    },

    mounted: function () {
        //console.log(this.engine);

    },

    methods: {
        clickRow: function () {
            if (this.is_enabled) {
                return
            }
            this.expandInfo = !this.expandInfo
        },
        openModal() {
            if (!this.$page.props.canManageSettings) {
                return
            }
            this.$refs.modalApikey.open()
        },
        // getEmbedCode() {
        //     fetch(this.$page.props.app_url + '/happyfox/widget/' + this.$page.props.user.current_team.slug)
        //     .then(response => response.text())
        //     .then(embedCode => {
        //         this.embedCode = embedCode;
        //         console.log(this.embedCode);
        //     })
        //     .catch(error => {
        //         console.error('There was an error!', error);
        //     });
        // },
        updateTrigger: function (data) {
            if (!data.apikey || !data.authcode || !data.domain || this.saving) {
                return
            }
            var url = this.$page.props.api_url + '/v1/happyfox/install'
            var params = {
                token: data.apikey,
                authcode: data.authcode,
                domain: data.domain
            }
            this.saving = true
            axios.post(url, params)
                .then(response => {
                    console.log(response.data);
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                    this.trigger = response.data
                    this.saving = false
                    this.$refs.modalApikey.closeModalForce()
                })
                .catch(e => {
                    console.error(e)
                    if (e.response && e.response.status === 400) {
                        let options = {
                            type: "danger",
                            timeout: -1,
                            position: "top-right",
                        }
                        this.$moshaToast("Please verify your Happyfox credentials", options)
                    }
                    this.saving = false
                });
        },
        confirmCopy: function () {
            let options = {
                type: "default",
                timeout: 6000,
                position: "top-right",
                hideProgressBar: false,
            }
            this.$moshaToast("Copied in your clipboard!", options)
        },
        errorCopy: function () {
            let options = {
                type: "danger",
                timeout: -1,
                position: "top-right",
            }
            this.$moshaToast("A browser error occured, link not copied", options)
        },
        deleteIntegration: function () {
            this.show_delete_modal = true
        },
        deleteIntegrationConfirmed: function () {
            this.show_delete_modal = false
            let url = this.$page.props.api_url + '/v1/integration-delete/' + this.trigger.id;
            var params = {};
            axios.post(url, params)
                .then(response => {
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Helpscout uninstalled", options)
                    this.trigger = null
                    this.engine = {}
                })
                .catch(e => {
                    console.error(e);
                });
        }
    },

    computed: {
        happyfox_api_key: {
            get: function () {
                if (this.trigger.token) {
                    return this.trigger.token.substring(0, 5) + "******" + this.trigger.token.substring(this.trigger.token.length - 5)
                }
                return ""
            },
            set: function (newValue) {
                // do nothing
            }
        },
        happyfox_canned_answer: {
            get: function () {
                if (this.trigger.token) {
                    return `https://${this.$page.props.user.current_team.slugname}.birdie.so/recorder?hfar={{ticket_id}}&hfce={{contact_email}}`
                }
                return ""
            },
            set: function (newValue) {
                // do nothing
            }
        },

        enabled: {
            get: function () {
                return this.trigger.enabled == 1
            },
            set: function (newValue) {
                // do nothing
            }
        },
    }
}

</script>
